import React from 'react'

import CommentFormDialog from '../CommentFormDialog'
import {
  BuildingTourFragmentFragment,
  useInsertBuildingTourCommentMutation
} from 'api/generated'
import { useUser } from 'context/auth/user'

export type BuildingTourCommentFormDialogProps = {
  buildingTour?: BuildingTourFragmentFragment
  openDialog: boolean
  onCancel: () => void
}

const BuildingTourCommentFormDialog: React.FC<
  BuildingTourCommentFormDialogProps
> = ({
  buildingTour,
  openDialog,
  onCancel
}: BuildingTourCommentFormDialogProps) => {
  const { dbUser } = useUser()
  const [insertBuildingTourComment, { loading, error }] =
    useInsertBuildingTourCommentMutation()

  return (
    <CommentFormDialog
      loading={loading}
      error={error}
      openDialog={openDialog}
      onCancel={onCancel}
      onSubmit={(data, onCompletedCallback) => {
        insertBuildingTourComment({
          variables: {
            object: {
              building_tour_id: buildingTour?.id,
              user_id: dbUser?.id,
              comment: data?.comment,
              files: {
                data: data?.files?.map(file => {
                  return {
                    path: file?.value,
                    folder: 'building-tour'
                  }
                })
              }
            }
          },
          onCompleted: data => {
            if (data?.buildingTourComment) {
              onCompletedCallback?.()
            }
          }
        })
      }}
    />
  )
}

export default BuildingTourCommentFormDialog
